import { sdkRequest } from '@eventbrite/http';
import DataLoader from 'dataloader';
import { SearchRetrievalContext } from './types';

const metricLoader = new DataLoader((keys) => {
    sdkRequest('/api/v3/log_engagement/', {
        method: 'POST',
        body: JSON.stringify(keys),
    });
    return Promise.resolve(keys);
});

function logEngagement(
    id: string,
    position: number,
    searchRetrievalContext: SearchRetrievalContext,
    logActionType: string,
) {
    const engagementRequestBody = {
        identity: {
            user_id: window.__SERVER_DATA__.user.publicId,
            tracking_code: null,
            device_latitude: null,
            device_longitude: null,
        },
        interface_context: {
            app: 'web',
            interface: 'search',
            sub_interface: '',
            // Position is position of interface on page (top to bottom left to right)
            // For search, there's only one
            position: '',
            tab_key: '',
            rank: position,
            event_id: id,
            campaign_id: null,
            action: logActionType,
        },
        retrieval_context: searchRetrievalContext,
    };
    metricLoader.load(engagementRequestBody);
}

export function logImpressionForSearch(
    id: string,
    position: number,
    searchRetrievalContext: SearchRetrievalContext,
) {
    logEngagement(id, position, searchRetrievalContext, 'impression');
}

export function logEventClickFromSearch(
    id: string,
    position: number,
    searchRetrievalContext: SearchRetrievalContext,
) {
    logEngagement(id, position, searchRetrievalContext, 'click');
}
